import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { render } from "react-dom";
import { Outlet, Route } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { CheckCircleIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function PasswordReset({ disabled }) {
  const { session, supabase } = useContext(AuthContext);
  const [sent, setSent] = useState(false);
  const requestPasswordResetLink = async () => {
    /**
     * Step 1: Send the user an email to get a password reset token.
     * This email contains a link which sends the user back to your application.
     */
    const { data, error } = await supabase.auth.resetPasswordForEmail(
      session.user.email,
      { redirectTo: "http://localhost:3000/auth/reset" }
    );
    setSent(true);
  };

  // Load user profile settings into the state
  // Do a deep compare to see if anything is different

  return (
    <div className="w-full">
      <label className="block text-xs text-gray-700 font-semibold">
        Password
      </label>
      <div className="flex mt-1 items-center space-x-2">
        <input
          type={"password"}
          disabled={true}
          value={"**************"}
          className={`border bg-white shadow-sm border-gray-300 rounded-md text-sm flex-1 text-gray-400`}
        />
        <button
          onClick={() => requestPasswordResetLink()}
          disabled={sent}
          className={
            sent
              ? "bg-gray-800 text-white rounded-md text-xs px-4 py-2.5 border-gray-300 font-medium"
              : "bg-white hover:bg-gray-50 border shadow-sm text-gray-600 rounded-md text-xs px-4 py-2.5 border-gray-300 font-medium"
          }
        >
          {sent ? (
            <div className="flex items-center space-x-2">
              <CheckCircleIcon className="w-4" />
              <p>Password request link sent</p>
            </div>
          ) : (
            "Request password reset link"
          )}
        </button>
      </div>
    </div>
  );
}
